if (!customElements.get('narvar-edd')) {
  customElements.define(
    'narvar-edd',
    class NarvarEdd extends HTMLElement {
      constructor() {
        super();
        this.productTags = this.dataset.productTags ? JSON.parse(this.dataset.productTags.replaceAll(`%27`, `"`)) : [];
        this.customerTags = this.dataset.customerTags ? JSON.parse(this.dataset.customerTags.replaceAll(`%27`, `"`)) : [];
        this.customerEmail = this.dataset.customerEmail;
      }

      connectedCallback() {
        this.init();
        this.observer = new MutationObserver(this.observerCallback.bind(this));
        this.observer.observe(this, { childList: true, subtree: true });
      }

      init() {
        window.narvar('promiseEddCalculator', {
          customerEmail: this.customerEmail || ``,
          customerTags: this.customerTags?.join(`,`) || ``,
          itemTags: this.productTags?.join(`,`) || ``
        });
      }

      observerCallback(mutationList, observer) {
        for (const mutation of mutationList) {
          if (mutation.type === 'childList') {
            const narvarWidget = this.querySelector('[data-narvar-widget]')?.firstChild;
            if (!narvarWidget) return;
            const narvarEdds = Array.from(narvarWidget?.lastChild?.childNodes);
            if (!narvarEdds.length) return

            const mainEdd = narvarEdds[0];
            const optionalEdds = narvarEdds.slice(1, narvarEdds.length);
            const optionalEddsWrapper = this.querySelector('[data-narvar-optional-edds]');

            if (!optionalEddsWrapper) return;

            optionalEddsWrapper.innerHTML = '';
            optionalEdds.forEach((optionalEdd) => {
              optionalEddsWrapper.appendChild(optionalEdd);
            });
            narvarWidget.prepend(mainEdd); 
            observer.disconnect();
          }
        }
      }
    }
  );
}